import type { CSSProperties } from 'react';
import { Colors } from '../../../shared/theme';
import { PPVFont, textStyles } from '../../../shared/theme/fonts-ppv';

export default {
    // ── Page wrapper ───────────────────────────────────────────
    pageWrapper: {
        minHeight: 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: Colors.white,
    } as CSSProperties,

    // ── Page Header ────────────────────────────────────────────
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: Colors.white,
        padding: '16px 24px',
        borderBottom: `1px solid ${Colors.grey100}`,
    } as CSSProperties,
    titleSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    } as CSSProperties,
    titleText: {
        ...textStyles.h2,
        color: Colors.grey800,
    } as CSSProperties,
    subtitleText: {
        ...textStyles.subtitle1,
        color: Colors.grey600,
    } as CSSProperties,
    createButton: {
        ...textStyles.h4,
        backgroundColor: Colors.violet,
        borderColor: Colors.violet,
        borderRadius: '48px',
        color: Colors.white,
        height: '44px',
        padding: '10px 24px',
        fontFamily: PPVFont.Regular,
    } as CSSProperties,

    // ── Request List ───────────────────────────────────────────
    defaultContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: Colors.white,
        padding: 20,
    } as CSSProperties,
    filterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        marginBottom: '16px',
        minHeight: '44px',
    } as CSSProperties,
    listTitleGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexShrink: 0,
    } as CSSProperties,
    listTitleText: {
        ...textStyles.h4,
        color: Colors.grey800,
    } as CSSProperties,
    countBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        height: '20px',
        borderRadius: '24px',
        padding: '0 4px',
        backgroundColor: Colors.grey600,
        ...textStyles.subtitle3,
        color: Colors.white,
    } as CSSProperties,
    filterChips: {
        display: 'flex',
        gap: '10px',
        flex: 1,
    } as CSSProperties,
    filterSelect: {
        minWidth: '148px',
    } as CSSProperties,

    // ── Modal ──────────────────────────────────────────────────
    modalForm: {
        width: 600,
    } as CSSProperties,
    modalTitle: {
        display: 'block',
        ...textStyles.h2,
        color: Colors.grey800,
        marginBottom: '24px',
    } as CSSProperties,
    docTypeLabel: {
        display: 'block',
        ...textStyles.body1,
        color: Colors.secondary,
        marginBottom: '8px',
    } as CSSProperties,
    branchSelect: {
        ...textStyles.body2,
        color: Colors.textPrimary,
        width: '100%',
    } as CSSProperties,
    selectOption: {
        ...textStyles.body2,
    } as CSSProperties,

    // ── Tooltip ────────────────────────────────────────────────
    tooltipContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
    } as CSSProperties,
    tooltipText: {
        ...textStyles.body3,
        color: Colors.white,
        whiteSpace: 'nowrap',
    } as CSSProperties,

    clearFilterText: {
        ...textStyles.button2,
        color: Colors.violet,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        alignSelf: 'center',
        paddingLeft: '8px',
        borderLeft: `1px solid ${Colors.backgroundNeutral}`,
    } as CSSProperties,

    // ── Alert container ────────────────────────────────────────
    alertContainer: {
        position: 'fixed',
        top: 24,
        right: 24,
        zIndex: 1010,
        width: '360px',
    } as CSSProperties,

    // ── Empty state ────────────────────────────────────────────
    emptyContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 0',
        gap: '4px',
    } as CSSProperties,
    emptyTitle: {
        ...textStyles.h4,
        color: Colors.grey400,
    } as CSSProperties,
    emptySubtitle: {
        ...textStyles.subtitle2,
        color: Colors.grey400,
    } as CSSProperties,
};
